"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _index = _interopRequireDefault(require("../../../elements/other/actions/index"));
var _paragraph = _interopRequireDefault(require("@site/pattern-library-core/paragraph"));
var _configContext = require("./config-context");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _price = _interopRequireDefault(require("@site/pattern-library-core/price"));
require("./common/marquee-rtb");
require("./common/trustpilot");
var _index2 = _interopRequireDefault(require("./common/media/index.js"));
/* eslint-disable complexity */

// eslint-disable-next-line import/no-unassigned-import

// eslint-disable-next-line import/no-unassigned-import

const Container = /*#__PURE__*/(0, _react2.styled)(_section.default)({
  name: "Container",
  class: "pl-cwkclfu",
  vars: {
    "cwkclfu-1": [({
      layout
    }) => layout === 'image-right' ? 'column-reverse' : 'column'],
    "cwkclfu-4": [({
      layout
    }) => layout === 'image-right' ? '0 var(--viewport-space--300)' : 'var(--viewport-space--300) 0'],
    "cwkclfu-5": [({
      layout
    }) => layout === 'image-right' ? 'row-reverse' : 'row']
  }
});
const MediaContent = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "MediaContent",
  class: "pl-m1rkfs2v"
});
const maxItemCount = 7; // max content item count
const ContentContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ContentContainer",
  class: "pl-c1himlcj"
});
const CtaContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CtaContainer",
  class: "pl-c1xialfp"
});
const Disclaimer = /*#__PURE__*/(0, _react2.styled)(_paragraph.default)({
  name: "Disclaimer",
  class: "pl-d1msqixc"
});

/**
 * MegaMarquee Component.
 *
 * @param {Object} props React props
 * @param {Array} props.items Grid Items
 * @param {Array} props.ctas Buttons
 * @param {Object} props.priceLockup price lockup
 * @param {Array} props.disclaimer Disclaimer
 * @param {Array} props.rtbList Rtb List Items
 * @param {Object} props.trustpilotCta Trustpilot Button
 * @param {Object} props.layout Marquee Layout Type
 * @param {string} props.verticalPadding Vertical Inner Spacing value
 * @param {Object} props.image Image
 * @param {Object} props.headlineLockup Headline Lockup
 * @param {string} props.partial Partial
 * @param {boolean} props.compactOnMobile Reduces height of the marquee on mobile
 * @param {String} props.introUrl Video URL
 * @param {String} props.introUrlWebm Video URL in WebM format
 * @param {String} props.introUrlLaptop Video URL for laptop
 * @param {String} props.introUrlLaptopWebm Video URL for laptop in WebM format
 * @returns {React.ReactElement} MegaMarquee Component
 * @public
 */
function MegaMarquee({
  id,
  _name,
  image,
  rtbList,
  domainSearch,
  ctas,
  priceLockup,
  trustpilotBar,
  layout = 'default',
  verticalPadding = 'small',
  headlineLockup,
  partial = '',
  compactOnMobile = false,
  disclaimer,
  introUrl,
  introUrlWebm,
  introUrlLaptop,
  introUrlLaptopWebm,
  videos
}) {
  return /*#__PURE__*/_react.default.createElement(_configContext.ConfigContext.Provider, {
    value: {
      layout
    }
  }, /*#__PURE__*/_react.default.createElement(Container, {
    id: `id-${id}`,
    _name: _name,
    padding: "unset",
    dataCy: "mega-marquee",
    verticalMargin: "none",
    verticalPadding: verticalPadding,
    layout: layout
  }, /*#__PURE__*/_react.default.createElement(MediaContent, {
    "data-layout": layout
  }, /*#__PURE__*/_react.default.createElement(_index2.default, {
    image: image,
    introUrls: {
      introUrl,
      introUrlWebm,
      introUrlLaptop,
      introUrlLaptopWebm
    },
    videos: videos
  })), /*#__PURE__*/_react.default.createElement(ContentContainer, {
    "data-cy": "content-container",
    "data-partial": partial,
    className: compactOnMobile ? 'compact-mobile' : ''
  }, /*#__PURE__*/_react.default.isValidElement(headlineLockup) ? /*#__PURE__*/_react.default.cloneElement(headlineLockup, {
    headlineSize: 'h2',
    disclaimer: null
  }) : headlineLockup, priceLockup && /*#__PURE__*/_react.default.createElement(_price.default, priceLockup), rtbList, domainSearch, ctas && /*#__PURE__*/_react.default.createElement(CtaContainer, {
    "data-cy": "cta-container",
    className: "cta-container"
  }, /*#__PURE__*/_react.default.createElement(_index.default, {
    actionsLayout: "button-set",
    ctas: ctas
  })), (disclaimer || headlineLockup?.props.disclaimer) && /*#__PURE__*/_react.default.createElement("div", {
    className: "disclaimer-container"
  }, /*#__PURE__*/_react.default.createElement(Disclaimer, {
    asType: "paragraph",
    size: -2,
    "data-cy": "disclaimer",
    text: disclaimer?.text || headlineLockup?.props?.disclaimer,
    tooltip: disclaimer?.tooltip || headlineLockup?.props?.disclaimerTooltip || headlineLockup?.props?.tooltip
  })), trustpilotBar)));
}
var _default = exports.default = MegaMarquee;
MegaMarquee.propTypes = {
  id: _propTypes.default.string,
  _name: _propTypes.default.string,
  headlineLockup: _propTypes.default.node,
  image: _propTypes.default.shape({
    portrait: _propTypes.default.shape(_patternLibraryUtils.bynderImageProps),
    landscape: _propTypes.default.shape(_patternLibraryUtils.bynderImageProps)
  }),
  ctas: _propTypes.default.arrayOf(_propTypes.default.shape(_index.default.propTypes)),
  priceLockup: _propTypes.default.object,
  rtbList: _propTypes.default.node,
  disclaimer: _propTypes.default.shape({
    text: _propTypes.default.string,
    tooltip: _propTypes.default.object
  }),
  domainSearch: _propTypes.default.node,
  trustpilotBar: _propTypes.default.node,
  layout: _propTypes.default.oneOf(['default', 'image-right']),
  partial: _propTypes.default.string,
  compactOnMobile: _propTypes.default.bool,
  ..._patternLibraryUtils.paddingProps
};